import type { ComponentProps } from "react";
import {
  isPostPreviewSupported,
  type PreviewSupportPost,
  SkedPreview,
} from "@dialogueconsulting/sked-preview";
import "@dialogueconsulting/sked-preview/dist/style.css";

import { cn } from "@/lib/utils";

type SkedPostPreviewProps = ComponentProps<typeof SkedPreview> & {
  previewClassName?: string;
};

export const SkedPostPreview = ({
  className,
  previewClassName,
  previewVariant,
  ...props
}: SkedPostPreviewProps) => {
  const resolvedPreviewVariant = previewVariant ?? "uplift";
  const previewPost = props.post as PreviewSupportPost | null;
  const isPreviewSupported = isPostPreviewSupported(previewPost);
  const isOtherNotificationPreview =
    (previewPost?.platform || previewPost?.platformType) === "OT";
  const shouldFillFrame = !isPreviewSupported || isOtherNotificationPreview;

  return (
    <div
      className={cn(
        "relative mx-auto max-w-full overflow-hidden rounded-lg bg-white",
        shouldFillFrame ? "w-full" : "w-fit",
        className
      )}
      data-preview-frame-variant={resolvedPreviewVariant}
      data-testid="sked-post-preview-frame"
    >
      <SkedPreview
        {...props}
        className={
          resolvedPreviewVariant === "uplift"
            ? cn("!rounded-none !border-0 !shadow-none", previewClassName)
            : undefined
        }
        previewVariant={resolvedPreviewVariant}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-[1] rounded-[inherit] border border-solid border-[#e6e6e6]"
      />
    </div>
  );
};
